document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-add-bundle').forEach(button => {
    if (button.dataset.bundleInit === 'true') return;
    button.dataset.bundleInit = 'true';

    button.addEventListener('click', function (e) {
      e.preventDefault();
      console.log('Add to cart button clicked');
      const variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;

      this.disabled = true;
      this.classList.add('tw-opacity-50', 'tw-cursor-not-allowed');
      console.log('Adding variant to cart:', variantId);

      const planId = this.getAttribute('data-selling-plan-id');
      const payload = {
        id: variantId,
        quantity: 1
      };
      if (planId) {
        payload.selling_plan = planId;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(res => res.json())
      .then(() => fetch(window.Shopify.routes.root + '?section_id=cart-drawer'))
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        if (!newDrawer) return;

        const currentDrawer = document.querySelector('cart-drawer');
        currentDrawer.replaceWith(newDrawer);
        requestAnimationFrame(() => {
          newDrawer.open();
          button.disabled = false;
          button.classList.remove('tw-opacity-50', 'tw-cursor-not-allowed');
        });
        console.log('Variant added to cart successfully');
      })
      .catch(err => {
        console.error(err);
        this.disabled = false;
        this.classList.remove('tw-opacity-50', 'tw-cursor-not-allowed');
      });
    });
  });
});
